/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 */

import {Component, inject} from '@angular/core';
import {
  FooterLinksConfig,
  LogoService,
} from '../../../shared/services/logo/logo.service';

const DYNAMIC_FOOTER_LINKS: {
  key: keyof FooterLinksConfig;
  text: string;
  href: string;
}[] = [
  {
    key: 'siemensDigitalProductPassport',
    text: 'links.siemens_battery_passport_text',
    href: 'links.siemens_battery_passport_link',
  },
  {
    key: 'aboutBatteryPassEU',
    text: 'links.battery_pass_eu_text',
    href: 'links.battery_pass_eu_link',
  },
  {key: 'teamcenterPCM', text: 'links.tcpcm_text', href: 'links.tcpcm_link'},
  {key: 'catenaX', text: 'links.catena_x_text', href: 'links.catena_x_link'},
];

function filterFooterLinks(config: FooterLinksConfig) {
  return DYNAMIC_FOOTER_LINKS.filter((link) => config[link.key]).map(
    ({text, href}) => ({text, href}),
  );
}

@Component({
  selector: 'app-public-viewer-shell',
  templateUrl: './public-viewer-shell.component.html',
  styleUrl: './public-viewer-shell.component.scss',
  standalone: false,
})
export class PublicViewerShellComponent {
  private readonly logoService = inject(LogoService);

  protected readonly logo = this.logoService.resolve();

  protected readonly filteredFooterLinks = filterFooterLinks(
    this.logoService.resolveFooterLinks(),
  );
}
